export default "__VITE_ASSET__CgI3HEOn__"